import { _$api } from '/var/www/html/node_modules/nuxt-api-party/dist/runtime/composables/$api'
import { _useApiData } from '/var/www/html/node_modules/nuxt-api-party/dist/runtime/composables/useApiData'
export const $suitmediaApi = (...args) => _$api('suitmediaApi', ...args)
export const useSuitmediaApiData = (...args) => _useApiData('suitmediaApi', ...args)
